// src/components/ShareButton.jsx
// Botón minimalista de compartir — Web Share API en móvil, copia link en desktop
import { useState } from 'react';
import { Share2, Link, Check } from 'lucide-react';

/**
 * @param {string} url       - URL canónica a compartir
 * @param {string} title     - Título para Web Share API
 * @param {string} text      - Descripción para Web Share API
 * @param {string} className - Clases extra opcionales
 */
export default function ShareButton({ url, title, text, className = '' }) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    // Móvil / Safari: usa la API nativa
    if (navigator.share) {
      try {
        await navigator.share({ url, title, text });
      } catch {
        // El usuario canceló — no es error
      }
      return;
    }

    // Desktop: copia al portapapeles
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback muy antiguo
      const el = document.createElement('input');
      el.value = url;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      onClick={handleShare}
      title={copied ? 'Enlace copiado' : 'Compartir'}
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg border transition-all duration-150 select-none
        ${copied
          ? 'border-emerald-400/50 text-emerald-400 bg-emerald-950/30'
          : 'border-slate-600/50 text-slate-400 hover:text-slate-200 hover:border-slate-400 bg-transparent'
        } ${className}`}
    >
      {copied
        ? <><Check className="w-3.5 h-3.5" /> Copiado</>
        : <><Share2 className="w-3.5 h-3.5" /> Compartir</>
      }
    </button>
  );
}
